import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CalendarDateSelector } from './calendar-date-selector';
import { FilterContainer } from './filter-container';
import { LocationChip } from './location-chip-container';
import { QuickFiltersContainer } from './quick-filters-container';

export const Container = () => {
  return (
    <div css={styles.container}>
      <div css={styles.group}>
        <CalendarDateSelector />
        <LocationChip />
      </div>
      <div css={styles.group}>{/* TODO: To be added later when Operatory view is available */}</div>
      <div css={styles.group}>
        <QuickFiltersContainer />
        <FilterContainer />
      </div>
    </div>
  );
};

const styles = {
  container: css`
    background: ${theme.colors.white};
    border-bottom: 1px solid ${theme.colors.neutral20};
    padding: ${theme.spacing(1)};
    gap: ${theme.spacing(0.5)};
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  group: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
};
